/**
 * This function removes duplicates from an array
 */
export var uniq = function uniq(arr) {
  return Array.from(new Set(arr));
};